// src/graphql/mutations/eventActionMutations.js

export const adminCreateEventActionBinding = `mutation AdminCreateEventActionBinding($input: CreateEventActionBindingInput!) {
    adminCreateEventActionBinding(input: $input) {
        success
        message
        error
        binding {
            id
            eventType
            jobType
            companyId
            paramMapping
            tenderIdField
            enabled
            description
            jobPriority
            condition
            createdAt
            updatedAt
        }
    }
}`;

export const adminUpdateEventActionBinding = `mutation AdminUpdateEventActionBinding($id: String!, $input: UpdateEventActionBindingInput!) {
    adminUpdateEventActionBinding(id: $id, input: $input) {
        success
        message
        error
        binding {
            id
            eventType
            jobType
            companyId
            paramMapping
            tenderIdField
            enabled
            description
            jobPriority
            condition
            createdAt
            updatedAt
        }
    }
}`;

export const adminDeleteEventActionBinding = `mutation AdminDeleteEventActionBinding($id: String!) {
    adminDeleteEventActionBinding(id: $id) {
        success
        message
        error
    }
}`;

export const adminEnableEventActionBinding = `mutation AdminEnableEventActionBinding($id: String!) {
    adminEnableEventActionBinding(id: $id) {
        success
        message
        error
        binding {
            id
            enabled
        }
    }
}`;

export const adminDisableEventActionBinding = `mutation AdminDisableEventActionBinding($id: String!) {
    adminDisableEventActionBinding(id: $id) {
        success
        message
        error
        binding {
            id
            enabled
        }
    }
}`;

export const adminCleanupEventActionLogs = `mutation AdminCleanupEventActionLogs($olderThanDays: Int!) {
    adminCleanupEventActionLogs(olderThanDays: $olderThanDays) {
        success
        message
        deletedCount
    }
}`;
